import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';
import { MainComponent } from '@app/main/main.component';
import { ClientsComponent } from '@app/features/clients/clients.component';
import { ClientComponent } from '@app/features/clients/client/client.component';
import { QuestionnairesComponent } from '@app/features/questionnaires/questionnaires.component';
import { UnauthorisedComponent } from '@app/unauthorised/unauthorised.component';
import { PageNotFoundComponent } from '@app/page-not-found/page-not-found.component';
import { SecurityAccessGuardService } from '@app/shared/guards/security-access.guard';
import { QuestionnaireAccessGuard } from '@app/shared/guards/questionnaire-access.guard';

const appRoutes: Routes = [
  {
    path: '',
    canActivate: [MsalGuard],
    children: [
      {
        path: '',
        canActivate: [SecurityAccessGuardService],
        redirectTo: 'main',
        pathMatch: 'full'
      },
      {
        path: 'main',
        canActivate: [SecurityAccessGuardService],
        component: MainComponent,
      },
      {
        path: 'clients',
        canActivate: [SecurityAccessGuardService],
        component: ClientsComponent
      },
      {
        path: 'clients/:clientId',
        canActivate: [SecurityAccessGuardService],
        component: ClientComponent
      },
      {
        path: 'questionnaires',
        canActivate: [SecurityAccessGuardService, QuestionnaireAccessGuard],
        component: QuestionnairesComponent,
      },
    ]
  },
  {
    path: 'unauthorised',
    component: UnauthorisedComponent
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent
  },
  {
    path: '**',
    redirectTo: 'page-not-found',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      {
        onSameUrlNavigation: 'reload',
        initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabled' : 'disabled'
      },
    ),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {
}
